import React from 'react';
import { string, number, shape, bool } from 'prop-types';
import { getActivityProgressTypeByVariantId, getActivityTitleByVariantId } from '@paddl/utils-js';
import { ActivityTimelineCardWrapper } from './ActivityTimelineCard.styles';
import { BigActivityTimelineCardContent, SmallActivityTimelineCardContent } from './content';
import { useWidth } from '../../Utils/useWidth';
export const ActivityTimelineCard = _ref => {
  let {
    variantId,
    title,
    subtitle,
    xpNumber,
    skills,
    percentageComplete,
    duration
  } = _ref;
  const progressType = getActivityProgressTypeByVariantId(variantId);
  const type = getActivityTitleByVariantId(variantId);
  const width = useWidth();
  return /*#__PURE__*/React.createElement(ActivityTimelineCardWrapper, {
    type: type
  }, width === 'sm' || width === 'xs' ? /*#__PURE__*/React.createElement(SmallActivityTimelineCardContent, {
    type: type,
    progressType: progressType,
    title: title,
    subtitle: subtitle,
    xpNumber: xpNumber,
    percentageComplete: percentageComplete,
    duration: duration
  }) : /*#__PURE__*/React.createElement(BigActivityTimelineCardContent, {
    type: type,
    progressType: progressType,
    title: title,
    subtitle: subtitle,
    xpNumber: xpNumber,
    skills: skills,
    percentageComplete: percentageComplete,
    duration: duration
  }));
};
ActivityTimelineCard.propTypes = {
  variantId: number.isRequired,
  title: string,
  subtitle: string,
  xpNumber: number,
  skills: number,
  percentageComplete: number,
  duration: shape({
    startDate: shape({
      day: number,
      month: number,
      year: number
    }),
    endDate: shape({
      day: number,
      month: number,
      year: number
    }),
    timeStamp: shape({
      day: number,
      month: number,
      year: number
    }),
    isCurrent: bool
  }).isRequired
};
ActivityTimelineCard.defaultProps = {
  title: '',
  subtitle: '',
  xpNumber: undefined,
  percentageComplete: null,
  skills: 1
};